import styled from 'styled-components';

export const Column = styled.div`
    @media screen and (min-width: 768px) {
        flex: 1 0 0;
    }
`;
